import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuBar from 'components/atoms/Editors/EditorMenuBar/EditorMenuBar.styles';

const EditorMenuBar = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuBar');

  return <StyledEditorMenuBar ref={ref} {...innerProps} />
});

EditorMenuBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuBar;
